var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTkFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2838_986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 15.3333C0 16.0406 0.280952 16.7189 0.781049 17.219C1.28115 17.719 1.95942 18 2.66667 18H21.3333C22.0406 18 22.7189 17.719 23.219 17.219C23.719 16.7189 24 16.0406 24 15.3333V12H0V15.3333Z",
    fill: "#D62612"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 15.9231C26 16.7391 25.6722 17.5218 25.0888 18.0988C24.5053 18.6758 23.714 19 22.8889 19H1.11111C0.285993 19 -0.50533 18.6758 -1.08878 18.0988C-1.67222 17.5218 -2 16.7391 -2 15.9231V2.07692C-2 1.26087 -1.67222 0.478245 -1.08878 -0.0987902C-0.50533 -0.675825 0.285993 -1 1.11111 -1H22.8889C23.714 -1 24.5053 -0.675825 25.0888 -0.0987902C25.6722 0.478245 26 1.26087 26 2.07692V15.9231Z",
    fill: "#E30917"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7642 13.5379C10.6134 13.5379 9.50966 13.0863 8.69588 12.2826C7.88211 11.4789 7.42494 10.3888 7.42494 9.25214C7.42494 8.1155 7.88211 7.02541 8.69588 6.22168C9.50966 5.41796 10.6134 4.96643 11.7642 4.96643C12.7116 4.96643 13.5867 5.27 14.3005 5.77929C13.8029 5.2201 13.1903 4.77215 12.5035 4.46533C11.8167 4.15851 11.0716 3.99987 10.3178 4C8.90743 4 7.55483 4.55335 6.55755 5.53832C5.56027 6.52328 5 7.85919 5 9.25214C4.99991 9.94192 5.13738 10.625 5.40459 11.2623C5.67179 11.8996 6.06348 12.4786 6.55729 12.9664C7.0511 13.4542 7.63736 13.8411 8.2826 14.1051C8.92783 14.3691 9.61939 14.505 10.3178 14.505C11.9053 14.505 13.3264 13.8143 14.3005 12.725C13.5633 13.2539 12.6754 13.5385 11.7642 13.5379ZM14.5942 9.41643L16.3588 9.81786L16.5179 11.5986L17.4494 10.0657L19.2141 10.4664L18.0251 9.11786L18.9559 7.58429L17.2903 8.28429L16.1013 6.935L16.2604 8.71643L14.5942 9.41643Z",
    fill: "#EEEEEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2838_986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTkFlag);
export default __webpack_public_path__ + "static/media/tk-flag.91218fd92923bd2bf875ee96bb64a761.svg";
export { ForwardRef as ReactComponent };